/* Fit Guide – supports BOTH types of variants (alpha XS/S/M/L/XL and numeric cups 32AA..48E)
   - Bra products: metafield → numeric-cup map → alpha map → generated → default
   - Non-bra products: default
   - SWAP: Underbust point shows Fullbust value, Fullbust point shows Underbust value
*/
(function () {
  const W = window, D = document;
  if (W.__FG_BOOTSTRAPPED__) return;
  W.__FG_BOOTSTRAPPED__ = true;

  /* ===== Config ===== */
  const DEFAULT_CM_RANGE = '100-102'; // fallback for non-bra or last safety
  const BASE_RANGE = { start: 102, end: 201 }; // generated fallback
  const INCREMENT_PER_VARIANT = { start: 1, end: 1 }; // step
  const FORCE_GENERATED = false; // debug switch

  /* When rendering callouts, swap keys: underbust ⇄ fullbust */
  const CALLOUT_SWAP = { underbust: 'fullbust', fullbust: 'underbust' };

  /* ===== BRA maps ===== */

  // Numeric cup-size → ranges (from your list)
  const BRA_TITLE_MAP = {
    "32aa": { underbust: "60.5-64.5", fullbust: "75-79" },
    "32a": { underbust: "66.5-71.5", fullbust: "80-87" },
    "32b": { underbust: "66.5-71.5", fullbust: "80-87" },
    "34a": { underbust: "72.5-76", fullbust: "88-92" },
    "36a": { underbust: "72.5-76", fullbust: "88-92" },
    "34b": { underbust: "72.5-76", fullbust: "88-92" },
    "32c": { underbust: "72.5-76", fullbust: "88-92" },
    "34c": { underbust: "72.5-76", fullbust: "88-92" },
    "38b": { underbust: "77-85", fullbust: "93-102" },
    "36c": { underbust: "77-85", fullbust: "93-102" },
    "38c": { underbust: "77-85", fullbust: "93-102" },
    "36d": { underbust: "77-85", fullbust: "93-102" },
    "34dd": { underbust: "77-85", fullbust: "93-102" },
    "36dd": { underbust: "77-85", fullbust: "93-102" },
    "38dd": { underbust: "86-94", fullbust: "103-112" },
    "38d": { underbust: "86-94", fullbust: "103-112" },
    "40b": { underbust: "86-94", fullbust: "103-112" },
    "40c": { underbust: "86-94", fullbust: "103-112" },
    "40d": { underbust: "86-94", fullbust: "103-112" },
    "40dd": { underbust: "95-103", fullbust: "113-122" },
    "40e": { underbust: "95-103", fullbust: "113-122" },
    "42dd": { underbust: "95-103", fullbust: "113-122" },
    "42e": { underbust: "95-103", fullbust: "113-122" },
    "44dd": { underbust: "104-112", fullbust: "123-132" },
    "44e": { underbust: "104-112", fullbust: "123-132" },
    "46dd": { underbust: "104-112", fullbust: "123-132" },
    "46e": { underbust: "104-112", fullbust: "123-132" },
    "48dd": { underbust: "113-117", fullbust: "133-137" },
    "48e": { underbust: "113-117", fullbust: "133-137" },
    // Teen Girls Bra Sizes
    "89years": { underbust: "58-59.5", fullbust: "64-67" },
    "910years": { underbust: "59.5-61", fullbust: "67-70" },
    "1112years": { underbust: "62.5-64", fullbust: "73-76" },
    "1314years": { underbust: "65.5-67", fullbust: "79-82" },
    "1516years": { underbust: "68.5", fullbust: "85" }
  };

  // Alpha (XS/S/M/L/XL) → ranges (grouping from your table)
  const BRA_ALPHA_MAP = {
    xs: { underbust: "60.5-64.5", fullbust: "75-79" },   // e.g., 32AA/early 32A
    s: { underbust: "66.5-71.5", fullbust: "80-87" },    // 32A/32B
    m: { underbust: "72.5-76", fullbust: "88-92" },      // 34A/36A/34B/32C/34C
    l: { underbust: "77-85", fullbust: "93-102" },     // 38B/36C/38C/36D/34DD/36DD
    xl: { underbust: "86-94", fullbust: "103-112" }     // 38DD/38D/40B/40C/40D
  };

  /* ===== Helpers ===== */
  const tidy = (n) => (+n).toFixed(2).replace(/\.00$/, '');
  const cmToIn = (cm) => (cm * 0.3937007874);
  const inchesStr = (range) => {
    if (!range) return "";
    const parts = String(range).split('-').map(s => parseFloat(s.trim()));
    if (parts.length === 1 && !isNaN(parts[0])) return tidy(cmToIn(parts[0]));
    if (parts.length === 2 && parts.every(n => !isNaN(n))) {
      return tidy(cmToIn(parts[0])) + '-' + tidy(cmToIn(parts[1]));
    }
    return range;
  };
  const qsa = (root, sel) => Array.prototype.slice.call(root.querySelectorAll(sel));
  const normKey = (k) => String(k || '').toLowerCase().replace(/[^a-z0-9]/g, '');

  const ALPHA_ALIASES = { xs: 'xs', s: 's', m: 'm', l: 'l', xl: 'xl', small: 's', medium: 'm', large: 'l', extra: 'x' };

  function closeDialog(dlg) {
    if (typeof dlg.close === 'function') {
      try { dlg.close(); } catch (_) { dlg.removeAttribute('open'); }
    } else {
      dlg.classList.remove('fg-open-fallback');
      D.documentElement.classList.remove('fg-lock');
    }
  }

  /* Variant metafield normalization (still supported if you add later) */
  function normalizeRanges(r) {
    const out = {}, arr = [];
    if (Array.isArray(r)) {
      r.forEach(v => arr.push(v));
    } else if (r && typeof r === 'object') {
      Object.keys(r).forEach(k => {
        const nk = normKey(k);
        out[nk] = r[k];
        arr.push(r[k]);
      });
    }
    return { byKey: out, byIndex: arr };
  }

  function ensureMapNormalized(pid) {
    const map = W['__FG_VARIANTS__' + pid] || {};
    if (map.__normalized) return map;
    Object.keys(map).forEach(vid => {
      if (vid === '__normalized') return;
      const e = map[vid] || {};
      const n = normalizeRanges(e.ranges || {});
      e._rangesByKey = n.byKey;
      e._rangesByIndex = n.byIndex;
      map[vid] = e;
    });
    map.__normalized = true;
    return map;
  }

  function setActiveTab(dlg, name) {
    qsa(dlg, '.fg-tab').forEach(t => {
      const on = t.getAttribute('data-fg-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    qsa(dlg, '.fg-pane').forEach(p => {
      const on = p.getAttribute('data-fg-pane') === name;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }

  function switchKidsTable(dlg) {
    const isInch = dlg.dataset.fgUnit === 'inch';
    qsa(dlg, '.fg-kids-table').forEach(table => {
      const isActive = table.getAttribute('data-fg-kids-table') === (isInch ? 'inch' : 'cm');
      table.hidden = !isActive;
    });
  }

  function convertTable(dlg) {
    if (dlg.dataset.kidsFitGuide === 'true') {
      switchKidsTable(dlg);
      return;
    }

    const table = dlg.querySelector('[data-fg-table]');
    if (!table) return;
    const isInch = dlg.dataset.fgUnit === 'inch';
    qsa(table, 'tbody tr').forEach(tr => {
      qsa(tr, 'td').forEach(td => {
        const idx = parseInt(td.getAttribute('data-fg-col'), 10);
        if (idx >= 3) {
          const text = td.getAttribute('data-cm') || td.textContent.trim();
          td.setAttribute('data-cm', text);
          td.setAttribute('data-inch', inchesStr(text));
          td.textContent = isInch ? td.getAttribute('data-inch') : td.getAttribute('data-cm');
        }
      });
    });
  }

  function setUnit(dlg, unit) {
    dlg.dataset.fgUnit = (unit === 'inch') ? 'inch' : 'cm';
    qsa(dlg, '.fg-unit-btn').forEach(b => b.classList.toggle('is-active', b.getAttribute('data-unit') === dlg.dataset.fgUnit));
    convertTable(dlg);
    if (dlg.dataset.kidsFitGuide !== 'true') {
      refreshCallouts(dlg);
    }
  }

  function activeVariantId(dlg) {
    const a = dlg.querySelector('.fg-pill.is-active');
    return a ? a.getAttribute('data-variant-id') : null;
  }

  function getVariantIndex(dlg, vid) {
    const pills = qsa(dlg, '.fg-pill');
    for (let i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-variant-id') === String(vid)) return i;
    }
    return 0;
  }

  function getVariantLabel(dlg, vid) {
    const pid = dlg.dataset.productId;
    const map = W['__FG_VARIANTS__' + pid];
    if (map && map[vid] && map[vid].label) return String(map[vid].label);
    const pill = dlg.querySelector('.fg-pill[data-variant-id="' + vid + '"]');
    return pill ? pill.textContent.trim() : '';
  }

  function getVariantData(dlg) {
    const pid = dlg.dataset.productId;
    const map = ensureMapNormalized(pid);
    const vid = activeVariantId(dlg);
    return vid ? { entry: map[vid], vid, map } : { entry: null, vid: null, map };
  }

  function generatedRangeForVariant(variantIndex) {
    const s = BASE_RANGE.start + INCREMENT_PER_VARIANT.start * variantIndex;
    const e = BASE_RANGE.end + INCREMENT_PER_VARIANT.end * variantIndex;
    return `${s}-${e}`;
  }

  // Try to derive multiple possible lookup keys from a variant label.
  function deriveLookupKeys(label) {
    const raw = normKey(label); // "32b", "xl", "s", "32bxs", etc.
    const keys = new Set();

    // 1) exact raw (for numeric cups like "32b")
    if (raw) keys.add(raw);

    // 2) alpha-only extraction (XS/S/M/L/XL present in mixed titles like "S / 32B")
    const alphaMatch = raw.match(/(xxl|xl|xs|s|m|l)/);
    if (alphaMatch) {
      const a = alphaMatch[1];
      const canonical = ALPHA_ALIASES[a] || a;
      if (canonical) keys.add(canonical);
    }

    // 3) space/slash separated tokens → add each token
    label.split(/[\/\-\|, ]+/).forEach(tok => {
      const nk = normKey(tok);
      if (nk) keys.add(nk);
    });

    return Array.from(keys);
  }

  /* Core resolver:
      Non-bra → DEFAULT
      Bra → metafield → title map (numeric cup) → alpha map → generated → default
      SWAP: underbust point shows fullbust; fullbust point shows underbust
  */
  function resolveRangeForCallout(dlg, dataPack, calloutIndex, calloutId) {
    const isBra = String(dlg.dataset.isBra || '').toLowerCase() === 'true';

    // requested key (underbust/fullbust), then swapped key to actually display
    const requested = normKey(calloutId);
    const keyWanted = CALLOUT_SWAP[requested] || requested; // swap here

    if (!isBra) return DEFAULT_CM_RANGE;

    const vid = dataPack.vid;
    const vIdx = getVariantIndex(dlg, vid);
    if (FORCE_GENERATED) return generatedRangeForVariant(vIdx);

    // 1) variant metafield (if you add later)
    const entry = dataPack.entry;
    let cmRange = '';
    if (entry) {
      if (entry._rangesByKey && entry._rangesByKey.hasOwnProperty(keyWanted)) {
        cmRange = entry._rangesByKey[keyWanted];
      }
      if ((!cmRange || String(cmRange).trim() === '') && entry._rangesByIndex && entry._rangesByIndex.length > calloutIndex) {
        cmRange = entry._rangesByIndex[calloutIndex];
      }
      if (cmRange && String(cmRange).trim() !== '') return cmRange;
    }

    // 2) title-based maps
    const label = getVariantLabel(dlg, vid);
    const keys = deriveLookupKeys(label);

    // 2a) numeric cup first (e.g., "32b")
    for (const k of keys) {
      if (BRA_TITLE_MAP[k] && BRA_TITLE_MAP[k][keyWanted]) {
        return BRA_TITLE_MAP[k][keyWanted];
      }
    }
    // 2b) then alpha map (e.g., "s", "xl")
    for (const k of keys) {
      const alpha = ALPHA_ALIASES[k] || k; // normalize
      if (BRA_ALPHA_MAP[alpha] && BRA_ALPHA_MAP[alpha][keyWanted]) {
        return BRA_ALPHA_MAP[alpha][keyWanted];
      }
    }

    // 3) generated fallback per variant index
    cmRange = generatedRangeForVariant(vIdx);
    if (cmRange && String(cmRange).trim() !== '') return cmRange;

    // 4) default
    return DEFAULT_CM_RANGE;
  }

  function refreshCallouts(dlg) {
    const dataPack = getVariantData(dlg);
    const isInch = dlg.dataset.fgUnit === 'inch';

    qsa(dlg, '.fg-callout').forEach((el, i) => {
      const idRaw = el.getAttribute('data-callout-id');
      const cmRange = resolveRangeForCallout(dlg, dataPack, i, idRaw);

      const lbl = el.querySelector('.fg-callout-label');
      if (!lbl) return;

      lbl.textContent =
        (isInch ? inchesStr(cmRange) : cmRange) +
        ' ' +
        (isInch ? 'IN' : 'CM');
    });
  }


  function initDialog(dlg) {
    if (dlg.__fg_inited) return;
    dlg.__fg_inited = true;

    // Close on backdrop click
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDialog(dlg); });

    // Defaults
    setActiveTab(dlg, dlg.querySelector('.fg-tab.is-active')?.getAttribute('data-fg-tab') || 'find');
    setUnit(dlg, dlg.dataset.unitDefault === 'inch' ? 'inch' : 'cm');
    refreshCallouts(dlg);

    // Variant change (theme event)
    D.addEventListener('variant:change', (evt) => {
      const v = evt.detail?.variant;
      if (!v || String(v.product_id) !== dlg.dataset.productId) return;
      const pill = dlg.querySelector('.fg-pill[data-variant-id="' + v.id + '"]');
      if (pill) {
        qsa(dlg, '.fg-pill').forEach(p => {
          const on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        refreshCallouts(dlg);
      }
    });

    // Fallback: observe <select name="id">
    const form = D.querySelector('form[action="/cart/add"]') || D.querySelector('form#product-form') || D.querySelector('product-form form');
    const select = form ? form.querySelector('[name="id"]') : null;
    if (select) {
      const fire = (vid) => D.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: parseInt(vid, 10), product_id: parseInt(dlg.dataset.productId, 10) } } }));
      select.addEventListener('change', e => fire(e.target.value));
      let last = select.value;
      const obs = new MutationObserver(() => { if (select.value !== last) { last = select.value; fire(last); } });
      obs.observe(select, { attributes: true, childList: true, subtree: true });
    }
  }

  /* Global delegated events */
  D.addEventListener('click', function (e) {
    // Open
    const openBtn = e.target.closest('.fitguide-trigger');
    if (openBtn) {
      const id = openBtn.getAttribute('aria-controls');
      const dlg = D.getElementById(id);
      if (!dlg) return;
      initDialog(dlg);
      if (typeof dlg.showModal === 'function') { dlg.showModal(); }
      else { dlg.classList.add('fg-open-fallback'); D.documentElement.classList.add('fg-lock'); }
      e.preventDefault();
      return;
    }
    // Close
    const closeBtn = e.target.closest('.fg-close');
    if (closeBtn) {
      const dlg = closeBtn.closest('dialog.fitguide-modal');
      if (dlg) closeDialog(dlg);
      e.preventDefault();
      return;
    }
    // Tabs
    const tabBtn = e.target.closest('.fg-tab');
    if (tabBtn) {
      const dlg = tabBtn.closest('dialog.fitguide-modal'); if (!dlg) return;
      setActiveTab(dlg, tabBtn.getAttribute('data-fg-tab'));
      e.preventDefault();
      return;
    }
    // Units
    const unitBtn = e.target.closest('.fg-unit-btn');
    if (unitBtn) {
      const dlg = unitBtn.closest('dialog.fitguide-modal'); if (!dlg) return;
      setUnit(dlg, unitBtn.getAttribute('data-unit'));
      e.preventDefault();
      return;
    }
    // Variant pills
    const pill = e.target.closest('.fg-pill');
    if (pill) {
      const dlg = pill.closest('dialog.fitguide-modal'); if (!dlg) return;
      qsa(dlg, '.fg-pill').forEach(p => {
        const on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      refreshCallouts(dlg);
      e.preventDefault();
    }
  });

  // ESC closes any open dialog
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa(D, 'dialog.fitguide-modal[open], dialog.fitguide-modal.fg-open-fallback').forEach(dlg => closeDialog(dlg));
  });
})();